
import { Vue, Component } from "vue-property-decorator";
import Score from "@/components/feedback/components/Score.vue";
import { UFFeedback } from "@/utils/literals/feedback";
import { FeedbackType } from "@/schemas/Enums";
import { mapState } from "vuex";

@Component({
  components: { Score },
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class Examples extends Vue {
  exampleGroupScore = 70;
  ex1Scores = [
    {
      user: "User1",
      score: 32,
    },
    {
      user: "User2",
      score: 50,
    },
    {
      user: "User3",
      score: 65,
    },
    {
      user: "User4",
      score: 40,
    },
    {
      user: "User5",
      score: 12,
    },
  ];
  ex2Scores = [
    {
      user: "User1",
      score: 32,
    },
    {
      user: "User2",
      score: 50,
    },
    {
      user: "User3",
      score: 65,
    },
    {
      user: "User4",
      score: 40,
    },
    {
      user: "User5",
      score: 96,
    },
  ];

  data(): any {
    return {
      currentPage: 1,
    };
  }

  getUFFb(key: string): string {
    return UFFeedback[key] || "";
  }

  changeEx(nb): void {
    if (nb == -1 && this.currentPage != 1) {
      this.currentPage = this.currentPage - 1;
    }
    if (nb == 1 && this.currentPage != 3) {
      this.currentPage = this.currentPage + 1;
    }
  }
}
